/* 🤖 this file was generated by svg-to-ts */
export const DfIconLinkedinSquare16: {
  name: 'linkedin-square-16';
  data: string;
} = {
  name: 'linkedin-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM9.957 6.37l-.176.007c-.735.056-1.1.463-1.316.781l-.036.053v-.72H6.734l.002.058c.019.713-.002 5.042-.002 5.042h1.695V8.742l.003-.113a.933.933 0 0 1 .053-.3c.122-.305.401-.62.87-.62.613 0 .859.467.859 1.153v2.729h1.695V8.666l-.005-.2c-.068-1.429-.88-2.096-1.947-2.096zm-4.161.089H4.1v5.1h1.696zM4.959 4C4.38 4 4 4.38 4 4.881c0 .49.368.881.937.881h.01l.124-.005c.519-.051.836-.421.836-.876C5.897 4.381 5.54 4 4.96 4z" fill-rule="evenodd"/></svg>`
};
